module.exports = __webpack_public_path__ + "img/img_map_index.ed00dee3.jpg";